export default "__VITE_ASSET__u2gE1h7R__"